<template>
<div>
  <div>
    <arksnackbar v-model="status"></arksnackbar>
  </div>
  <v-layout row justify-center>

    <v-text-field hide-details ref="pnrtext" :label="$t('PNR-No')" mask="##########" v-model="pnrno" v-on:change="$emit('kodonchange');">
    </v-text-field>

    <v-btn margin="6px 8px" icon color="primary" @click.stop="dialogShow()">
      <v-icon>search</v-icon>
    </v-btn>

    <customdialog v-model="dialog2" title="PNR Arama">

      <!-- Begin Arama Kriterleri ******************************************************************************-->
      <div class="layout">
        <v-text-field v-model="prm.Isim" :label="$t('Name-Inquiry')"></v-text-field>
        <v-text-field v-model="prm.Kayit_Tarihi1" type="date" :label="$t('Period-v2') +  '1'"></v-text-field>
        <v-text-field v-model="prm.Kayit_Tarihi2" type="date" :label="$t('Period-v2') + '2'"></v-text-field>
        <btnprogres v-model="status.loading" title="Ara" @click="Ara()"></btnprogres>

      </div>
      <!-- End Arama Kriterleri  *******************************************************************************-->

      <!-- Begin Data Table ************************************************************************************-->
      <v-data-table :headers="tableheaders" :items="tabledata" :loading="status.loading" hide-actions class="elevation-1">

        <template slot="items" slot-scope="props">
          <tr @click="Sec(props.item.PNR_No)">
            <td>{{ props.item.PNR_No }}</td>
            <td>{{ props.item.Isim }}</td>
            <td>{{ props.item.Cari_Kod }}</td>
            <td>{{ props.item.Kayit_Tarihi }}</td>
          </tr>
        </template>
      </v-data-table>
      <!-- End Data Table *************************************************************************************** -->

    </customdialog>

  </v-layout>

</div>
</template>

<script>
import tool from '../tools'
import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'
import btnprogres from '@/components/app/coper/comp/btnprogres.vue'
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  components: {
    arksnackbar,
    btnprogres,
    customdialog,

  },

  props: ['value'],
  computed: {
    pnrno: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
  },

  data() {
    return {
      error: "",
      prm: {},
      load: false,
      dialog2: false,
      tableheaders: [{
          text: this.$t('PNR-No'),
          align: 'left',
          sortable: false,
          value: 'PNR_No'
        },
        {
          text: this.$t('Name'),
          value: 'Isim'
        },
        {
          text: this.$t('Currentcode_label'),
          value: 'Cari_Kod'
        },
        {
          text: this.$t('Registration-Date'),
          value: 'Kayit_Tarihi',
          format: 'MM-DD-YYYY',
          type: "date"
        },
      ],
      tabledata: [],
      status: tool.NewSatatus(),

    }
  },

  methods: {
    Ara: Ara,
    Sec: Sec,
    dialogShow: dialogShow

  }

}

function dialogShow() {
  this.prm.Kayit_Tarihi1 = tool.Now_yyyy_MM_dd();
  this.prm.Kayit_Tarihi2 = tool.Now_yyyy_MM_dd();
  this.dialog2 = true;
}

function Sec(v) {
  this.pnrno = v;
  this.$emit('kodonchange');
  this.dialog2 = false;
}

function Ara() {
  this.tabledata = [];

  if (this.status.loading === false) {
    this.status.loading = true;
    setTimeout(() => {
      tool.http_post(this, 'PNRAra', this.prm).then((response) => {
        this.tabledata = response.body;
        this.status.loading = false;

      }, (response) => {
        this.status = tool.responseToStatus(response);
      })

    }, 500)
  }

}
</script>
